var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterSvgrepoCom4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set-Filled",
    transform: "translate(-365.000000, -413.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378,440 C374.134,440 371,436.908 371,433.094 C371,429.279 375.372,425.629 378,423 C380.733,425.697 385,429.279 385,433.094 C385,436.908 381.866,440 378,440 L378,440 Z M378,413 C373.12,417.949 365,424.82 365,432 C365,439.18 370.82,445 378,445 C385.18,445 391,439.18 391,432 C391,424.82 383.077,418.077 378,413 L378,413 Z M377.967,425.505 C376.094,427.516 373.012,429.802 373.012,432.719 C373.012,435.636 375.245,438 378,438 C380.755,438 382.988,435.636 382.988,432.719 C382.988,429.802 379.914,427.567 377.967,425.505 L377.967,425.505 Z",
    id: "water"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSvgrepoCom4);
export default __webpack_public_path__ + "static/media/water-svgrepo-com-4.5cb996ab6f4aa07df51d102e3674db89.svg";
export { ForwardRef as ReactComponent };